import { render } from "./AudioPlayer.vue?vue&type=template&id=5cabbb47&scoped=true&ts=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts"

import "./AudioPlayer.vue?vue&type=style&index=0&id=5cabbb47&scoped=true&lang=scss"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cabbb47"]])

export default __exports__